export default __webpack_public_path__ + "static/media/selectPics.9b773a04.png";